import { Observable } from 'rxjs';

import { Folder } from '@efficiently/models';

/**
 * Abstract store that defines the public API for managing folders.
 * Acts as a dependency injection token, decoupling consumers from the concrete implementation.
 */
export abstract class FolderStore {
	/**
	 * Observable stream of folders.
	 * Emits on initial load.
	 */
	public abstract readonly folders$: Observable<Folder[]>;

	/**
	 * The last error that occurred during a load operation.
	 * Emits `null` when there is no error.
	 */
	public abstract readonly error$: Observable<string | null>;
}
